import cx from 'classnames'
import React, { useContext, useEffect, useState } from 'react'
import ReactGA from 'react-ga'
import { useLocation } from 'react-router-dom'

import { CHANNEL_PATH, DEFAULT_CHANNEL_ID } from './constants'
import './App.scss'
import GalleryContainer from './GalleryContainer'
import GraphContainer from './GraphContainer'
import Header from './Header'
import UserContext, { UserContextType } from './UserContext'
import realtimeService from './RealtimeService'

const App = () => {
  const location = useLocation()
  const {
    userContext: { isFullscreen, isReadOnly, channelId },
    setChannelId,
    setIsReceiving,
  } = useContext(UserContext) as UserContextType
  const [isInitialized, setIsInitialized] = useState(false)
  const [realtimeTimestamp, setRealtimeTimestamp] = useState(0)
  const [archivePath, setArchivePath] = useState('')
  const [initialQueryString] = useState(document.location.search.substring(1))
  const containerClassName = cx('AppContainer', { fullScreen: isFullscreen })
  const className = cx('App', { fullScreen: isFullscreen })

  useEffect(() => {
    if (!isInitialized) {
      return
    }
    setArchivePath('')
    const { pathname, search } = location
    const pageview = `${pathname}${search}`
    ReactGA.pageview(pageview)
    if (search.length > 0) {
      const newUrl = new URL(window.origin)
      window.history.replaceState({}, '', newUrl) // hide our big url
    } else {
      const [, type, ...typeParts] = pathname.split('/')
      if (type === 'archive') {
        setArchivePath(typeParts.join('/'))
      } else if (type === 'listen') {
        if (!isReadOnly) {
          console.log('editor cannot be listener') // TODO: support?
          return
        }
        const newChannelId = typeParts[0] || DEFAULT_CHANNEL_ID
        if (channelId !== newChannelId) {
          setChannelId(newChannelId)
        }
      }
    }
  }, [location, isReadOnly, setChannelId, isInitialized])

  useEffect(() => {
    if (!isInitialized) {
      realtimeService.init(() => {
        setIsInitialized(true)
      })
      if (!channelId && !isReadOnly) {
        setChannelId(DEFAULT_CHANNEL_ID)
      }
    }
  })

  useEffect(() => {
    if (isInitialized && channelId) {
      if (isReadOnly && !realtimeTimestamp) {
        const controlPath = `${CHANNEL_PATH}/${channelId}/control`
        realtimeService.endpoint(controlPath).on('value', (snapshot) => {
          const controlData = snapshot.val() || {}
          const { timestamp, isActive } = controlData
          setIsReceiving(isActive)
          setRealtimeTimestamp(timestamp)
        })
      } else {
        // const path = `${CHANNEL_PATH}/${channelId}/control/isActive`
        // realtimeService.set(path, true)
      }
    }
  }, [isInitialized, channelId, isReadOnly, setIsReceiving, realtimeTimestamp])

  return (
    <div className={containerClassName}>
      <Header />
      {isInitialized && (
        <div className={className}>
          <GalleryContainer />
          <GraphContainer
            archivePath={archivePath}
            initialQueryString={initialQueryString}
            realtimeTimestamp={realtimeTimestamp}
          />
        </div>
      )}
    </div>
  )
}

export default App
